<script lang="ts">
    import { goto } from "$app/navigation"
    import {
        FootnoteClass,
        SearchResult,
        getTopLevelClass,
        isRenderItem,
        isWeighProcessable,
    } from "@circleofa/acim-engine"
    import { altKeyDown } from "@utils/underhood/registerHotkey"
    import { createEventDispatcher } from "svelte"
    import {
        ContextMenuViewportSelection,
        FocusSetting,
    } from "@utils/highlights/directive-logic/highlight-listener-permissions"
    import { SquintEventEmitter } from "@utils/highlights/directive-logic/focusser"
    import {
        ReadyTracker,
        ReadyTrackerStatus,
    } from "@utils/highlights/directive-logic/ready-tracker"
    import ResultBlock from "./ResultBlock.svelte"
    import type { RedrawEventDispatcher } from "@utils/highlights/directive-logic/highlights-directive"
    import { setKeyedPagePopWords } from "../book/[notation]/KeyedPage.svelte"

    export let forceInstantFirstPaint = false
    export let disableSelection = false
    export let focusOn: FocusSetting | null = FocusSetting.WORDS
    export let squintEventEmitter = new SquintEventEmitter()

    const readyTracker = new ReadyTracker<SearchResult>()
    $: readyTracker.updateList(searchResults.slice(0, limit))

    let loading = true

    // If we get a change in limit or results, lets re-do loading
    $: if (searchResults) loading = true

    $: if ($readyTracker === ReadyTrackerStatus.ALL) {
        loading = true
        // All are painted, so let's go
        squintEventEmitter.reset()
        squintEventEmitter.measure() // Measure twice cut once - just kidding
        squintEventEmitter.slice()
        loading = false
    }

    export let className = ""
    export { className as class }

    export let searchResults: SearchResult[]
    export let limit: number
    export let directOpen = false
    export let visitedResetKey: unknown = null

    let visitedList: Set<SearchResult> | null = null
    export let viewportSelection: ContextMenuViewportSelection =
        ContextMenuViewportSelection.SCROLL_CONTAINER

    let lastSearchResults: SearchResult[] | null = null
    const initialVisitedResetKey = {}
    let lastVisitedResetKey: unknown = initialVisitedResetKey
    $: if (searchResults != lastSearchResults || visitedResetKey !== lastVisitedResetKey) {
        lastSearchResults = searchResults
        lastVisitedResetKey = visitedResetKey
        visitedList = new Set<SearchResult>()
    }

    export let dispatch = createEventDispatcher()

    export let redrawEventDispatcher: RedrawEventDispatcher
</script>

{#each searchResults.slice(0, limit) as result, index (result)}
    {@const renderItem = isRenderItem(result.target) ? result.target : null}
    {@const symbol =
        result.target instanceof FootnoteClass
            ? result.target.renderItem
            : isWeighProcessable(result.target)
              ? result.target
              : null}
    {@const visited = !!(visitedList && visitedList.has(result))}
    {@const go = () => {
        if (renderItem) setKeyedPagePopWords(result.wordRanges)
        if (visitedList) {
            visitedList.add(result)
            // Assignment to trigger reactivity
            visitedList = visitedList
            console.log(visitedList)
        }
        dispatch("navigate")
        goto("/book/" + result.path)
    }}
    <ResultBlock
        {squintEventEmitter}
        {focusOn}
        on:go={go}
        {index}
        {readyTracker}
        {redrawEventDispatcher}
        {className}
        {symbol}
        {renderItem}
        {result}
        {visited}
        {forceInstantFirstPaint}
        {disableSelection}
        {viewportSelection}
        {directOpen}
    />
{/each}
